import { useEffect, useState } from "react";
import { api } from "../lib/api";

const TASK_TITLES = { picture: "Describe the picture", question: "Answer the question" };

function Take({ attemptId, rec, isFinal }) {
  const [url, setUrl] = useState("");
  const [failed, setFailed] = useState(false);
  const task = rec.task || "picture";

  useEffect(() => {
    if (!rec.available) return undefined;
    let objectUrl = "";
    api.get(`/attempts/${attemptId}/speaking/${rec.take}`, { params: { task }, responseType: "blob" })
      .then((r) => { objectUrl = URL.createObjectURL(r.data); setUrl(objectUrl); })
      .catch(() => setFailed(true));
    return () => objectUrl && URL.revokeObjectURL(objectUrl);
  }, [attemptId, rec.take, rec.available, task]);

  const id = `speaking-take-${task === "picture" ? "" : "question-"}${rec.take}`;
  return (
    <li className="py-4 border-b border-foreground/15 last:border-0" data-testid={id}>
      <div className="flex items-center gap-2 text-sm font-bold">
        Take {rec.take}
        {isFinal && <span className="overline !text-signal border border-signal px-1.5" data-testid={`${id}-final`}>scored</span>}
      </div>
      {!rec.available || failed ? (
        <p className="mt-2 text-xs text-muted-foreground">Audio not available for this take.</p>
      ) : url ? (
        <audio controls src={url} className="mt-2 w-full" data-testid={`${id}-audio`} />
      ) : (
        <p className="mt-2 text-xs text-muted-foreground font-mono-fig">Loading audio…</p>
      )}
      {rec.transcript && <p className="mt-2 text-sm text-foreground/80 italic">"{rec.transcript}"</p>}
    </li>
  );
}

export default function SpeakingRecordings({ attemptId, recordings, title = "Speaking recordings" }) {
  if (!recordings?.length) return null;
  const groups = ["picture", "question"]
    .map((task) => [task, recordings.filter((r) => (r.task || "picture") === task)])
    .filter(([, list]) => list.length);
  return (
    <div className="neu p-6" data-testid="speaking-recordings">
      <h3 className="text-lg font-bold">{title}</h3>
      {groups.map(([task, list]) => {
        const last = Math.max(...list.map((r) => r.take));
        return (
          <div key={task} className="mt-3" data-testid={`speaking-recordings-${task}`}>
            {groups.length > 1 && <div className="overline">{TASK_TITLES[task]}</div>}
            <ul className="mt-1">
              {list.map((r) => <Take key={`${task}-${r.take}`} attemptId={attemptId} rec={r} isFinal={r.take === last} />)}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
